import styled from 'styled-components';

import { h2Text, h3Text, namedBreakpoints } from 'theme';

export const CmsTileGridContentRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${namedBreakpoints.mdDown}) {
    margin-top: 58px;
  }

  @media (min-width: ${namedBreakpoints.mdUp}) {
    flex: 0.5;
    padding-left: 60px;
    min-width: 50%;
    overflow: auto;
    max-height: 100%;
  }
`;

export const CmsTileModalHeading = styled.h2`
  ${h2Text};

  margin-top: 0;
  margin-bottom: 27px;
`;

export const CmsTileModalSubheading = styled.h3`
  ${h3Text};

  margin-top: 0;
  margin-bottom: 16px;
`;
